module.exports = __webpack_public_path__ + "fonts/SourceHanSans-Bold.1df76a9.woff";